import {
  UI_COLOR_BORDER_DIVIDER_SOFT,
  UI_COLOR_SECONDARY,
  UI_COLOR_SECTION_ICON_BG,
  UI_COLOR_TEXT_ICON,
  UI_COLOR_TEXT_PRIMARY,
  UI_COLOR_WHITE
} from '../../../constants/uiColors'

export const rbacDetailCardBorder = 'var(--app-card-border)'

export const rbacSummaryCardSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '10px',
  p: '18px 20px',
  mb: 2,
  borderRadius: 'var(--app-card-radius)',
  backgroundColor: UI_COLOR_WHITE,
  border: rbacDetailCardBorder,
  boxShadow: 'var(--app-card-shadow)'
}

export const rbacUserSummaryCardSx = {
  ...rbacSummaryCardSx,
  backgroundImage: 'none',
  filter: 'none',
  '--client-header-font-size': '12px',
  '--client-header-font-weight': 600,
  '--client-header-text-color': UI_COLOR_TEXT_PRIMARY,
  '--client-header-icon-color': UI_COLOR_TEXT_ICON
}

export const rbacSectionIconBoxSx = {
  width: 28,
  height: 28,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  backgroundColor: UI_COLOR_SECTION_ICON_BG,
  flexShrink: 0,
  '& svg': {
    width: 16,
    height: 16,
    margin: 0,
    flexShrink: 0,
    display: 'block'
  }
}

export const rbacDetailsCardSx = {
  mb: 2,
  borderRadius: 'var(--app-card-radius)',
  backgroundColor: UI_COLOR_WHITE,
  border: rbacDetailCardBorder,
  boxShadow: 'var(--app-card-shadow)',
  overflow: 'hidden'
}

export const rbacDetailsCardHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  px: '20px',
  py: '18px'
}

export const rbacDetailsCardGridSx = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: 'repeat(4, minmax(0, 1fr))' },
  gap: '12px',
  p: '18px 22px 22px 22px'
}

export const rbacDetailsFieldSx = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: 60,
  px: '14px',
  py: '10px',
  borderRadius: 'var(--app-card-inner-radius)',
  border: 'var(--app-card-inner-border)',
  backgroundColor: UI_COLOR_WHITE
}

export const rbacSummaryMetaItemSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  minWidth: 0
}

export const rbacSummaryMetaTextSx = {
  color: UI_COLOR_TEXT_PRIMARY,
  fontSize: '12px',
  lineHeight: 1.2,
  whiteSpace: 'nowrap'
}

export const rbacSummaryTitleSx = {
  color: UI_COLOR_SECONDARY,
  textTransform: 'uppercase',
  lineHeight: 1.15
}

export const rbacSectionCardSx = {
  mb: 2,
  borderRadius: 'var(--app-card-radius)',
  backgroundColor: UI_COLOR_WHITE,
  border: rbacDetailCardBorder,
  boxShadow: 'var(--app-card-shadow)',
  overflow: 'hidden'
}

export const rbacSectionHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  px: '20px',
  py: '18px'
}

export const rbacSectionTitleSx = {
  color: UI_COLOR_TEXT_ICON,
  fontSize: 15,
  fontWeight: 800,
  lineHeight: 1.2,
  letterSpacing: 0,
  textTransform: 'uppercase'
}

export const rbacSectionDividerSx = {
  flexBasis: '100%',
  width: '100%',
  borderTop: `1.5px solid ${UI_COLOR_BORDER_DIVIDER_SOFT}`
}

export const RBAC_DETAIL_ICON_COLOR = UI_COLOR_TEXT_ICON
